import React from "react";
import "./UI/dragontiger.css";
import ReactDOM from 'react-dom/client';

import { Howl } from "howler";
import resultCards from "../../non_timer/funCard/UI/resultCards";
import GameBox from "./UI/gamebox";
// import Close from "./UI/close";
import duploseSound from "../../../../../assets/sounds/duplose.mp3";
import winSoundFile from "../../../../../assets/sounds/win.mp3";
import cardFallSound from "../../../../../assets/sounds/slide.mp3";
import betSoundFile from "../../../../../assets/sounds/bet.mp3";
import clearSoundFile from "../../../../../assets/sounds/clear.mp3";
import takeSoundFile from "../../../../../assets/sounds/take.mp3";
import exitSoundFile from "../../../../../assets/sounds/exit.mp3";
import betChipSnd from "../../../../../assets/sounds/betoncard.mp3";
// import staranimation from "../../../../../assets/games/d_up/staranimation.gif"
import { connect } from "react-redux";
import dragonsparkle from "../../../../js/games/sparkanim";
import dragonTiger_bgi from "../../../../../assets/games/dragon_tiger/DT_BG.png"
import CardCSS from "../../../../../library/Card/Card";
import winPopupBG from '../../../../../assets/games/win_popup/win_popup.png';
import BetPlacedChip from "../../../../../library/Chips/BetChip";

class DragonTigerTimer extends React.Component {
    // class DragonTigerTimer extends React.Component {
    constructor(props) {
        super(props);
        this.GameBox = React.createRef();
        this.handleResize = this.handleResize.bind(this)
        this.resultCardsArray = [];
        this.state = {
            balanceLbl: 0,
            totalBetAmt: 0,
            betidReq: ["dr", "tr", "ti", "dbig", "dsml", "tbig", "tsml"],
            winAmount: 0,
            isBetSent: false,
            isGameActive: true,
            dt_isSpectSent: false,
            infoText: this.props.language.Play_Njoy,
            betBtnStatus: 0,
            betBtnTxt: this.props.language.Prev,
            totalBetAmount: 0,
            isstaranimation: false,
            betPanelIds: [],
            myBetAmt: 0,
            chipValue: 0,
            winCover: false,
            betAmount: 0,
            enableKeyboard: false,
            isResultShowing: false,
            selectedChipVal: 10,

            isPlayingBet: false,

        }
        this.innerLimits = {};
        this.dragonsparklemw = 1;
        this.cardSound = this.initializeCardFallSound()
        // Class variables
        this.sparkleImagesLoaded = 0;
        this.sparkleFrame = null; // holds requestAnimationFrame ID
        this.dragonSparkleImgEl = null;
        const preloadBG = new Image();
        preloadBG.src = winPopupBG; // Adjust as needed
    }

    initializeBetSound = () => {
        try {
            const betSound = new Howl({
                src: [betChipSnd],
                html5: true, // Enable HTML5 Audio for mobile compatibility
            });
            this.setState({
                betSound,
                isPlayingBet: false,
            });
            return betSound;
        } catch (error) {
            console.error("Error initializing bet sound:", error);
            return null;
        }
    };

    initializeCardFallSound = () => {
        try {
            const cardSound = new Howl({
                src: [cardFallSound],
                html5: true, // Enable HTML5 Audio for mobile compatibility
            });
            return cardSound;
        } catch (error) {
            console.error("Error initializing bet sound:", error);
            return null;
        }
    };

    playCardFallSound() {
        if (typeof this.cardSound.stop === "function") {
            this.cardSound.stop()
            this.cardSound.play()
        } else {
            this.cardSound = this.initializeCardFallSound()
            this.cardSound.stop()
            this.cardSound.play()
        }
    }

    initializeWinSound = () => {
        try {
            const winSound = new Howl({
                src: [winSoundFile],
                html5: true, // Enable HTML5 Audio for mobile compatibility
            });
            return winSound;
        } catch (error) {
            console.error("Error initializing bet sound:", error);
            return null;
        }
    }

    initializeBet1Sound = () => {
        try {
            const betSound = new Howl({
                src: [betSoundFile],
                html5: true, // Enable HTML5 Audio for mobile compatibility
            });
            return betSound;
        } catch (error) {
            console.error("Error initializing bet sound:", error);
            return null;
        }
    }

    initializeloseSound = () => {
        try {
            const loseSound = new Howl({
                src: [duploseSound],
                html5: true, // Enable HTML5 Audio for mobile compatibility
            });
            return loseSound;
        } catch (error) {
            console.error("Error initializing bet sound:", error);
            return null;
        }
    }

    initializetakeSound = () => {
        try {
            const takeBtnSnd = new Howl({
                src: [takeSoundFile],
                html5: true, // Enable HTML5 Audio for mobile compatibility
            });
            return takeBtnSnd;
        } catch (error) {
            console.error("Error initializing bet sound:", error);
            return null;
        }
    }

    initializeClearSound = () => {
        try {
            const clearSound = new Howl({
                src: [clearSoundFile],
                html5: true, // Enable HTML5 Audio for mobile compatibility
            });
            return clearSound;
        } catch (error) {
            console.error("Error initializing bet sound:", error);
            return null;
        }
    }

    initializeExitSound = () => {
        try {
            const exitSound = new Howl({
                src: [exitSoundFile],
                html5: true, // Enable HTML5 Audio for mobile compatibility
            });
            return exitSound;
        } catch (error) {
            console.error("Error initializing bet sound:", error);
            return null;
        }
    }


    playPokerBetSound = (chipSound) => {

        const { isPlayingBet } = this.state;
        let currentSound = chipSound;

        if (isPlayingBet || typeof currentSound.stop === 'function') {
            currentSound.stop();
        }


        if (!chipSound) {
            currentSound = this.initializeBetSound();
        }


        if (currentSound) {

            currentSound.play();
            this.setState({
                isPlayingBet: true,
            });
        } else {
            console.error("Invalid sound object. Unable to play sound.");
        }

    };

    componentDidMount() {
        window.addEventListener("resize", this.handleResize)
        this.preloadSparkAnim();

        this.resetBet = {
            dragon: { dr: 0, dbig: 0, dsml: 0 },
            tie: { ti: 0 },
            tiger: { tr: 0, tbig: 0, tsml: 0 },
        };

        this.betObj = {
            dragon: { dr: 0, dbig: 0, dsml: 0 },
            tie: { ti: 0 },
            tiger: { tr: 0, tbig: 0, tsml: 0 },
        };

        this.undoArray = [];
        this.winSound = this.initializeWinSound();
        this.loseSound = this.initializeloseSound();
        this.betSound = this.initializeBet1Sound();
        this.takeBtnSnd = this.initializetakeSound();
        this.clearSound = this.initializeClearSound();
        this.exitSound = this.initializeExitSound();
        // this.betChipSound = new Audio(betChipSnd);
        this.betChipSound = this.initializeBetSound();

        this.betimg = ["dr_img", "tr_img", "ti_img", "dbig_img", "dsml_img", "tbig_img", "tsml_img"];
        this.coinId = ["dr", "tr", "ti", "dbig", "dsml", "tbig", "tsml"];
        this.table_timeout1 = null;
        this.table_timeout2 = null;
        this.table_timeout3 = null;
        this.table_timeout4 = null;
        this.table_timeout5 = null;
        this.table_timeout6 = null;
        this.table_timeout7 = null;
        this.table_timeout8 = null;
        this.table_timeout9 = null;
        this.table_timeout10 = null;
        this.table_timeout11 = null;
        this.table_timeout12 = null;
        this.table_timeout13 = null;
        this.table_timeout14 = null;
        this.table_timeout15 = null;

        if (this.props.dtt_chipValues) {
            let newChips = this.props.dtt_chipValues.split(",");
            console.log(newChips[0]);
            let initChipVal = newChips[0];
            let lblTxt;
            if (initChipVal >= 1000 && initChipVal <= 999999) {
                lblTxt = "K"
            } else if (initChipVal >= 1000000 && initChipVal <= 999999999) {
                lblTxt = "M"
            } else if (initChipVal > 999999999) {
                lblTxt = "B"
            }

            this.state.selectedChipVal = initChipVal;
        }

        document.getElementById('iospopup').style.display = 'block';
        // if (this.props.isIphone) {
        // } else {
        //     document.getElementById('iospopup').style.display = 'none';
        // }

        // document.getElementById("dt_exitBtn").disabled = true;
        // this.disableBtn("exit_img");
        this.table_timeout13 = setTimeout(() => {
            // document.getElementById("dt_exitBtn").disabled = false;
            this.enableBtn("exit_img");
            if (!this.state.isResultShowing) {
                this.setState({
                    enableKeyboard: true
                })
            }
            document.addEventListener("keyup", this.dt_handleKeyboardEvent);
        }, 1000);


        if (this.props.dt_innerLimits) {
            this.innerLimits = this.props.dt_innerLimits.split("|");
            for (let t = 0; t < this.innerLimits.length; t++) {
                this.innerLimits[t] = this.innerLimits[t].split("-");
            }
        }

        if (document.getElementById("betBoxCover")) {
            document.getElementById("betBoxCover").style.display = "block";
        }

        this.setState({
            balanceLbl: this.props.balance,
            winCover: true
        })
        // this.getAllIds();

        this.disableBtn("dealBtn_dtt");
        this.disableBtn("unDoBtn_dtt");
        this.disableBtn("clrBtn_dtt");
        this.disableBtn("doubleBtn_dtt");

        this.resutlsTarget = "";
        this.targetGameState = "";
        this.winBetArray = [];
        this.allIds = [];


        this.updateGameState()

        if (this.props.gameState && this.props.gameState.history) {
            this.update_DT_GameState();
        }
        // if (this.props.gameState.handId) {
        //     this.handId = this.props.gameState.handId;
        // }

        // const { childRefDT } = this.props;
        // childRefDT(this);
        const { childRef } = this.props;
        childRef(this);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize)
        document.removeEventListener("keyup", this.dt_handleKeyboardEvent);
        if (document.getElementById("betBoxCover")) {
            document.getElementById("betBoxCover").style.display = "none";
        }
        this.setState({
            enableKeyboard: false,
            winCover: false
        })
    }

    handleResize() {
        // alert(123456)
        console.log(JSON.stringify(this.undoArray))
        this.setBetPlaces()
        this.setPrevBtnOnResize()
    }

    setBetPlaces() {
        let allElements = ["ti", "dr", "tr", "dbig", "dsml", "tbig", "tsml"]
        allElements.map(ele => document.getElementById(ele).innerHTML = '')
        let allGame = {}
        this.undoArray.forEach(ele => {
            let key = Object.keys(ele)[0]
            let value = Object.values(ele)[0]
            if (allGame[key]) {
                allGame[key] += value
            } else {
                allGame[key] = value
            }
        })
        console.log("DTT_123456", this.undoArray)
        console.log("DTT_123456", allGame)
        Object.keys(allGame).map(ele => {
            // alert(ele)
            const container = document.getElementById(ele);
            console.dir(container)

            const root = ReactDOM.createRoot(container);
            // document.getElementById(ele).innerHTML = `<div> <p class="goldCoin_dr" } /> <span class="t_Count" id="${ele}_id"> ${allGame[ele]} </span </div>`;
            root.render(<div className="betPlacedChip"><BetPlacedChip betAmount={allGame[ele]} gameId={20} chipString={this.props.dtt_chipValues} /></div>);

        })
    }

    setPrevBtnOnResize() {
        if (this.state.infoText.startsWith("Bet Accepted")) {
            this.disableBtn("clrBtn_dtt")
            this.disableBtn("unDoBtn_dtt")
            this.disableBtn("doubleBtn_dtt")
            this.disableBtn("dealBtn_dtt")
        } else if (this.undoArray.length > 0) {
            this.enableBtn("clrBtn_dtt")
            this.enableBtn("unDoBtn_dtt")
            this.enableBtn("doubleBtn_dtt")
            this.enableBtn("dealBtn_dtt")
            document.getElementById("dealBtn_dtt").classList.add("dr_bt_active");
        } else if (this.props.gameState.betRequest.betString) {
            this.disableBtn("clrBtn_dtt")
            this.disableBtn("unDoBtn_dtt")
            this.disableBtn("doubleBtn_dtt")
            this.enableBtn("dealBtn_dtt")
        }
    }

    preloadSparkAnim() {
        this.sparkleImages = {};
        this.sparkleImagesLoaded = 0;

        for (let n = 1; n <= 100; n++) {
            const spark_img = new Image();
            const sparkImageName = `sparkanimation${n}`;
            spark_img.src = dragonsparkle[sparkImageName];

            spark_img.onload = () => {
                this.sparkleImages[sparkImageName] = spark_img;
                this.sparkleImagesLoaded++;
                if (this.sparkleImagesLoaded === 100) {
                    console.log('All sparkle images preloaded');
                }
            };

            spark_img.onerror = () => {
                this.sparkleImagesLoaded++;
                console.warn(`Failed to load sparkle image ${sparkImageName}`);
            };
        }

    }



    updateGameState() {
        if (this.props.gameState.handId != undefined) {
            if (this.props.gameState.handId == this.props.gameState.oldHandId) {
                document.getElementById("betBoxCover").style.display = "block";
                this.setState({
                    betBtnStatus: 1,
                    betBtnTxt: this.props.language.BetOK,
                    isBetSent: true,
                    disBetBtn: 1,
                    disClearBtn: 1,
                    disDoubleBtn: 1,
                    winCover: true,
                    infoText: this.props.language.BetAccepted + Number(this.props.gameState.betRequest.betAmount.toFixed(2)),
                    totalBetAmt: this.props.gameState.betRequest.betAmount,
                    totalBetAmount: this.props.gameState.betRequest.betAmount
                })

                this.updateBetString();
                const flatObj = { ...this.betObj.dragon, ...this.betObj.tie, ...this.betObj.tiger };

                this.undoArray = Object.entries(flatObj).filter(([key, value]) => value > 0).map(([key, value]) => ({ [key]: value }));

                this.setBetChipPlaces()

            } else {
                // alert(123)
                this.setState({
                    betBtnStatus: 0,
                    betBtnTxt: this.props.language.Prev,
                    disDoubleBtn: 0,
                    disClearBtn: 0,
                    disZoomBtn: 0,
                    winCover: false,
                    betBtnStatus: 0,
                    infoText: this.props.language.Play_Njoy,
                    totalBetAmt: 0,
                    undoArray: [],
                });
                // this.cleareBets()
                this.newGame()
                if (this.props.gameState.betRequest == undefined) {
                    this.setState({ disBetBtn: 1 });
                } else {
                    this.setState({ disBetBtn: 0 });
                    this.enableBtn("dealBtn_dtt")
                }

                if (document.getElementById("betBoxCover")) {
                    document.getElementById("betBoxCover").style.display = "none";
                }
            }

        } else {
            // alert(456)
            if (this.props.gameState.betRequest) {
                this.setState({ disBetBtn: 0 });
            } else {
                this.setState({ disBetBtn: 1 });
            }

            this.setState({
                betBtnStatus: 0,
                betBtnTxt: this.props.language.Prev,
                disDoubleBtn: 0,
                disClearBtn: 0,
                disZoomBtn: 0,
                winCover: false,
            });
            console.log(this.state.betString.length);

            console.log(document.getElementById("betBoxCover"))

            // if (document.getElementById("betBoxCover")) {
            //     document.getElementById("betBoxCover").style.display = "none";
            // }
        }
    }

    setBetChipPlaces() {
        for (let j = 0; j < this.coinId.length; j++) {
            let betId = this.coinId[j];
            const container = document.getElementById(betId);
            const root = ReactDOM.createRoot(container);
            // document.getElementById(betId).innerHTML = `<div> <p class="goldCoin_dr" } /> </div>`;
            switch (betId) {
                case "dr":
                case "dbig":
                case "dsml":
                    if (this.betObj.dragon[betId] > 0) {
                        let num_id = betId + "_id";
                        let dr_id_bet = this.betObj.dragon[betId];
                        root.render(<div className="betPlacedChip "><BetPlacedChip betAmount={dr_id_bet} gameId={20} chipString={this.props.dtt_chipValues} /></div>);

                        // document.getElementById(betId).innerHTML = `<div> <p class="goldCoin_dr" } /> <span class="t_Count" id=${num_id}> ${dr_id_bet} </span </div>`;
                    }
                    break;
                case "ti":
                    if (this.betObj.tie[betId] > 0) {
                        let num_id = "ti_id";
                        let ti_id_bet = this.betObj.tie[betId];
                        root.render(<div className="betPlacedChip "><BetPlacedChip betAmount={ti_id_bet} gameId={20} chipString={this.props.dtt_chipValues} /></div>);
                        // document.getElementById(betId).innerHTML = `<div> <p class="goldCoin_dr" } /> <span class="t_Count" id=${num_id}> ${ti_id_bet} </span </div>`;
                    }
                    break;
                case "tr":
                case "tbig":
                case "tsml":
                    if (this.betObj.tiger[betId] > 0) {
                        let num_id = betId + "_id";
                        let tr_id_bet = this.betObj.tiger[betId];
                        root.render(<div className="betPlacedChip "><BetPlacedChip betAmount={tr_id_bet} gameId={20} chipString={this.props.dtt_chipValues} /></div>);
                        // document.getElementById(betId).innerHTML = `<div> <p class="goldCoin_dr" } /> <span class="t_Count" id=${num_id}> ${tr_id_bet} </span </div>`;
                    }
                    break;
            }
        }
    }

    disableBtn(btnId) {
        // alert(btnId)
        let disBtn = document.getElementById(btnId);
        if (disBtn) {
            disBtn.classList.add("disBtn");
            disBtn.disabled = true;
        }
    }

    enableBtn(btnId) {
        let enableBtn = document.getElementById(btnId);
        if (enableBtn) {
            enableBtn.classList.remove("disBtn");
            enableBtn.disabled = false;
            enableBtn.style.zIndex = "150";
        }
    }

    dragonTigerResults(gameResult) {

        this.setState({ isResultShowing: true, dt_isSpectSent: false, enableKeyboard: false, winCover: true })

        if (document.getElementById("betBoxCover")) {
            document.getElementById("betBoxCover").style.display = "block";
            document.getElementById("betBoxCover").style.zIndex = 300;
        }
        this.resutlsTarget = gameResult;
        this.getResults(gameResult);
        this.setState({ isBetSent: false });


        if (this.state.totalBetAmt == 0 && gameResult.winAmount > 0) {
            //    alert(" 0000000000000000000000000000000000  ");
            this.setState({
                winCover: true,
                totalBetAmt: this.props.gameState.betRequest.betAmount,
                // totalBetAmount: this.props.gameState.betRequest.betAmount
            })

            // document.getElementById("betBoxCover").style.display = "block";
            // document.getElementById("betBoxCover").style.zIndex = 99;

            this.enableBtn("dealBtn_dtt");
            this.disableBtn("unDoBtn_dtt");
            this.disableBtn("clrBtn_dtt");

            this.updateBetString();

            console.log(this.betObj);

            for (let j = 0; j < this.coinId.length; j++) {
                let betId = this.coinId[j];
                const container = document.getElementById(betId);
                const root = ReactDOM.createRoot(container);
                // document.getElementById(betId).innerHTML = `<div> <p class="goldCoin_dr" } /> </div>`;
                switch (betId) {
                    case "dr":
                    case "dbig":
                    case "dsml":
                        if (this.betObj.dragon[betId] > 0) {
                            let num_id = betId + "_id";
                            let dr_id_bet2 = this.betObj.dragon[betId];
                            // document.getElementById(betId).innerHTML = `<div> <p class="goldCoin_dr" } /> <span class="t_Count" id=${num_id}> ${dr_id_bet2} </span </div>`;
                            root.render(<div className="betPlacedChip "><BetPlacedChip betAmount={dr_id_bet2} gameId={20} chipString={this.props.dtt_chipValues} /></div>);

                        }
                        break;
                    case "ti":
                        if (this.betObj.tie[betId] > 0) {
                            let num_id = "ti_id";
                            let ti_id_bet2 = this.betObj.tie[betId];
                            // document.getElementById(betId).innerHTML = `<div> <p class="goldCoin_dr" } /> <span class="t_Count" id=${num_id}> ${ti_id_bet2} </span </div>`;
                            root.render(<div className="betPlacedChip "><BetPlacedChip betAmount={ti_id_bet2} gameId={20} chipString={this.props.dtt_chipValues} /></div>);

                        }
                        break;
                    case "tr":
                    case "tbig":
                    case "tsml":
                        if (this.betObj.tiger[betId] > 0) {
                            let num_id = betId + "_id";
                            let tr_id_bet2 = this.betObj.tiger[betId];
                            // document.getElementById(betId).innerHTML = `<div> <p class="goldCoin_dr" } /> <span class="t_Count" id=${num_id}> ${tr_id_bet2} </span </div>`;
                            root.render(<div className="betPlacedChip "><BetPlacedChip betAmount={tr_id_bet2} gameId={20} chipString={this.props.dtt_chipValues} /></div>);

                        }
                        break;
                }
            }
        }
    }

    update_DT_GameState(newGameState) {
        console.log("DragTiger Game State ");
        console.log(this.props.gameState.history);
        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ");
        this.updateGameState()
        this.targetGameState = this.props.gameState;
        this.GameBox.updateHistory(this.props.gameState.history);
        console.log(this.targetGameState);
    }

    updatePlayerInfo() {
        console.log("DTT: Update Palyer Balance")
        this.setState({ balanceLbl: this.props.balance, totalBetAmount: 0 });
    }

    updateMessage(erroCode) {
        console.log("Update messages " + this.props.infoText);
        this.setState({ infoText: this.props.infoText });
        //console.log(erroCode);
        if (erroCode == "game.bet.invalid") {
            this.updateBetString();
        } else if (erroCode == "game.bet.accepted") {
            console.log(this.state.totalBetAmt) //Don't delete
            this.setState({ isBetSent: true });
        }
    }

    dt_GetTime() {
        if (this.props.dt_timeSend) {
            console.log("*************  -----------------------  ***************************");
            console.log(this.props.dt_timeSend);
            console.log("*************  -----------------------  ***************************");
            // console.log(this.props.dt_timeSend);
            // console.log(GameBox);
            if (this.GameBox) {
                this.GameBox.sendTimer(this.props.dt_timeSend);
            }
        }
    }

    exitGame() {
        this.setState({ isGameActive: false, enableKeyboard: false });
        console.log("Exit Dragon Tiger Game. ")
        document.removeEventListener("keyup", this.dt_handleKeyboardEvent);
        console.log(this.GameBox);
        if (this.GameBox) {
            this.GameBox.clearTimer_fn();
        }
    }

    updateBetString() {
        console.log("Game State betstring: ")
        if (this.props.gameState && this.props.gameState.betRequest && this.props.gameState.betRequest.betString) {
            console.log(this.props.gameState.betRequest.betString);
            let newStr = this.props.gameState.betRequest.betString.replace(/,/g, "|");
            let newStr1 = newStr.replace(/ /g, "0");
            console.log(newStr1)
            let newStr2 = newStr1.split('|');
            console.log(newStr2);

            for (let z = 0; z < newStr2.length; z++) {
                switch (z) {
                    case 0:
                        this.betObj.dragon["dr"] = Number(newStr2[0]);
                        break;
                    case 1:
                        this.betObj.tiger["tr"] = Number(newStr2[1]);
                        break;
                    case 2:
                        this.betObj.tie["ti"] = Number(newStr2[2]);
                        break;
                    case 3:
                        this.betObj.dragon["dbig"] = Number(newStr2[3]);
                        break;
                    case 4:
                        this.betObj.dragon["dsml"] = Number(newStr2[4]);
                        break;
                    case 5:
                        this.betObj.tiger["tbig"] = Number(newStr2[5]);
                        break;
                    case 6:
                        this.betObj.tiger["tsml"] = Number(newStr2[6]);
                        break;
                    default:
                        break;
                }
                console.log(this.betObj);
            }
            console.log(this.betObj);
        }
    }

    dt_handleKeyboardEvent = (evt) => {
        console.log(evt);
        console.log(evt.code);
        if (this.state.isGameActive) {
            switch (evt.code) {
                case "Enter":
                case "NumpadEnter":
                    //console.log(this.props.gameState);
                    //V1 change condition with buttonStaus number.
                    if (this.state.betBtnStatus == 1 && this.state.enableKeyboard) {
                        if (document.getElementById("dt_timeSpan") && document.getElementById("dt_timeSpan").innerHTML > 5) {
                            if (document.getElementById("dealBtn_dtt") && !document.getElementById("dealBtn_dtt").disabled && Number(document.getElementById("betAmt").innerHTML.split(": ")[1]) > 0) {
                                this.betSound.play();
                                console.log("<----- Bet OK --->")
                                this.deal();
                                break;
                            }
                        }
                    } else if (this.state.betBtnStatus == 0 && this.state.enableKeyboard) {
                        if (!document.getElementById("dealBtn_dtt").disabled && this.props.gameState.betRequest && this.props.gameState.betRequest.betAmount > 0) {
                            this.betSound.play();
                            this.rebetFun();
                            break;
                        }
                    }
                    break;
                case "KeyC":
                    if (document.getElementById("dt_timeSpan").innerHTML > 5 && this.state.betBtnStatus == 1 && this.state.enableKeyboard) {
                        if (document.getElementById("dealBtn_dtt") && !document.getElementById("dealBtn_dtt").disabled) {
                            if (document.getElementById('iospopup').style.display == "none") {
                                this.clearSound.play();
                            }

                            //console.log("Clear");  
                            this.disableBtn("dealBtn_dtt");
                            this.disableBtn("unDoBtn_dtt");
                            this.disableBtn("clrBtn_dtt");

                            document.getElementById("dealBtn_dtt").classList.remove("dr_bt_active");
                            this.cleareBets();
                            //this.betObj = this.initBet;
                            this.setState({ undoArray: [] });
                        }
                    }
                    break;
                // case 'Escape':
                //     //console.log('Esc');
                //     if (document.getElementById("dt_exitBtn").disabled == false) {
                //         document.removeEventListener("keyup", this.dt_handleKeyboardEvent);
                //         this.exitSound.play();
                //         this.closeGame();
                //     }
                //     break;
                default:
                    break;
            }
        }
    }

    dragonsparkleanimat = () => {
        if (this.dragonsparklemw < 101) {
            const sparkledragon = `sparkanimation${this.dragonsparklemw}`;
            //console.log(sparkledragon)
            const starssprinklemw = dragonsparkle[sparkledragon];
            //console.log(starssprinklemw)
            if (document.getElementById("dragon_sprkl")) {
                document.getElementById("dragon_sprkl").src = starssprinklemw
            }
            this.dragonsparklemw++;
        }
        else {
            this.dragonsparklemw = 1;
            clearInterval(this.dragponsparkl)
            //document.getElementById("sparkID").src = ""
        }
    }

    startSparkleAnim = () => {
        this.dragonsparklemw = 1;
        this.lastSparkFrameTime = 0;
        this.sparkleFrame = requestAnimationFrame(this.animateSparkle);
    };

    animateSparkle = (timestamp) => {
        if (this.dragonsparklemw > 100) {
            cancelAnimationFrame(this.sparkleFrame);
            this.sparkleFrame = null;
            this.setState({
                winAmount: 0
            })
            return;
        }

        // ~30fps: one frame every ~33ms
        if (!this.lastSparkFrameTime || timestamp - this.lastSparkFrameTime >= 33) {
            const sparkleKey = `sparkanimation${this.dragonsparklemw}`;
            const sparkleImg = this.sparkleImages?.[sparkleKey];

            if (this.dragonSparkleImgEl && sparkleImg) {
                this.dragonSparkleImgEl.src = sparkleImg.src;
            }

            this.dragonsparklemw++;
            this.lastSparkFrameTime = timestamp;
        }

        this.sparkleFrame = requestAnimationFrame(this.animateSparkle);
    };


    getResults(resultRes) {
        if (document.getElementById("betBoxCover")) {
            document.getElementById("betBoxCover").style.display = "block";
            document.getElementById("betBoxCover").style.zIndex = 300;
        }
        //console.log(resutlsTarget)
        this.resultCardsArray = [];
        this.winBetArray = [];
        this.setState({ enableKeyboard: false })
        this.removeGlow();

        this.resultCardsArray.push(resultRes.dragonCards, resultRes.tigerCards);
        for (let r = 0; r < resultRes.rs.length; r++) {
            this.winBetArray.push(resultRes.rs[r])
        }
        this.showCards();
    }

    showCards() {
        this.setState({ enableKeyboard: false, winCover: true });
        this.state.enableKeyboard = false;
        if (document.getElementById("betBoxCover")) {
            document.getElementById("betBoxCover").style.display = "block";
            document.getElementById("betBoxCover").style.zIndex = 300;
        }

        var resImg = [];

        // let cardSound = new Audio(cardFallSound);
        // let cardSound2 = new Audio(cardFallSound);
        if (this.state.isGameActive) {
            if (document.getElementById('iospopup').style.display == "none") {
                // cardSound.play();
            }

            this.table_timeout2 = setTimeout(() => {
                if (document.getElementById('iospopup').style.display == "none") {
                    // cardSound.play();
                }

            }, 700);
        }

        console.log(this.resultCardsArray)

        for (let i = 0; i < this.resultCardsArray.length; i++) {
            for (let a = 0; a < resultCards.length; a++) {
                if (this.resultCardsArray[i] == resultCards[a].rsc_val) {
                    resImg.push(resultCards[a].src);
                }
            }
        }

        if (resImg != '') {
            if (document.getElementById("betBoxCover")) {
                document.getElementById("betBoxCover").style.display = "block";
                document.getElementById("betBoxCover").style.zIndex = 300;
            }
            let dragonWinCard = document.getElementById('dragonWinCard');
            let tigerWinCard = document.getElementById('tigerWinCard');
            this.table_timeout3 = setTimeout(() => {
                if (dragonWinCard) {
                    // dragonWinCard.innerHTML = `<img class="dragon_card" src=${resImg[0]} />`
                    // dragonWinCard.innerHTML = <CardCSS cardTitle={this.resultCardsArray[0]}></CardCSS>
                    this.playCardFallSound()
                    const root = ReactDOM.createRoot(dragonWinCard);
                    root.render(<CardCSS newClassName="dragon_card" cardTitle={this.resultCardsArray[0]} />);
                }
            }, 50)
            this.table_timeout4 = setTimeout(() => {
                if (tigerWinCard) {
                    // tigerWinCard.innerHTML = `<img class="tiger_card" src=${resImg[1]} />`
                    // tigerWinCard.innerHTML = <CardCSS cardTitle={this.resultCardsArray[1]}></CardCSS>
                    this.playCardFallSound()
                    const root = ReactDOM.createRoot(tigerWinCard);
                    root.render(<CardCSS newClassName={"tiger_card"} cardTitle={this.resultCardsArray[1]} />);
                }
            }, 500)
        }
        this.table_timeout5 = setTimeout(() => {
            this.winBoxHighilights();
        }, 1500)
    }

    /*********************** WIN BOXES HIGHILIGHTS *********************/
    winBoxHighilights() {
        if (this.resutlsTarget.winAmount > 0) {
            if (this.state.isGameActive) {
                if (document.getElementById('iospopup').style.display == "none") {
                    this.winSound.play();
                }

                this.setState({ isstaranimation: true })
            }
            this.setState((prev) => {
                return {
                    ...prev,
                    infoText: this.props.language.WonHand,
                    winAmount: this.resutlsTarget.winAmount,
                    winCover: true,
                    totalBetAmount: 0,
                    // totalBetAmount: prev.totalBetAmount - this.resutlsTarget.winAmount
                }
            });

            if (document.getElementById("betBoxCover")) {
                document.getElementById("betBoxCover").style.zIndex = 99;
            }
            this.table_timeout7 = setTimeout(() => {
                let body = {
                    sessionId: sessionStorage.getItem('sessionId'),
                    CN: "GET_GAME_STATE",
                    object: {
                        playerId: Number(this.props.playerId),
                        gameId: this.props.gameId,
                    },
                };
                this.props.network.sendof(body);
                let pinfo_body = {
                    CN: "GET_PLAYER_INFO",
                    object: {
                        gameId: Number(this.props.gameId),
                        playerId: Number(this.props.playerId),
                    },
                    sessionId: sessionStorage.getItem('sessionId'),
                };
                this.props.network.sendof(pinfo_body);


                this.setState({
                    enableKeyboard: true,
                    isResultShowing: false
                })
                // this.setState({ infoText: this.props.language.Play_Njoy })

                // if (document.getElementById("betBoxCover")) {
                //     document.getElementById("betBoxCover").style.display = "none";
                //     document.getElementById("betBoxCover").style.zIndex = 99;
                // }


                // this.TakeAmount_fn();

                // let dragonWinCard = document.getElementById('dragonWinCard');
                // let tigerWinCard = document.getElementById('tigerWinCard');
                // if (dragonWinCard) {
                //     dragonWinCard.innerHTML = ``
                // }
                // if (tigerWinCard) {
                //     tigerWinCard.innerHTML = ``
                // }

                // this.betObj.dragon["dr"] = 0;
                // this.betObj.dragon["dbig"] = 0;
                // this.betObj.dragon["dsml"] = 0;
                // this.betObj.tie["ti"] = 0;
                // this.betObj.tiger["tr"] = 0;
                // this.betObj.tiger["tbig"] = 0;
                // this.betObj.tiger["tsml"] = 0;

                // this.setState({
                // betBtnStatus: 0,
                // betBtnTxt: this.props.language.Prev,
                // infoText: this.props.language.Play_Njoy,
                // totalBetAmt: 0,
                // winCover: false,
                // winAmount: 0,
                // undoArray: [],
                // });
                this.enableBtn("dealBtn_dtt");
                this.undoArray = []

                // for (let j = 0; j < this.coinId.length; j++) {
                //     let betId = this.coinId[j];
                //     const container = document.getElementById(betId);
                //     const root = ReactDOM.createRoot(container);
                //     // document.getElementById(betId).innerHTML = `<div> <p class="goldCoin_dr" } /> </div>`;
                //     root.render(<div className="betPlacedChip "></div>);


                //     if (document.getElementById((betId + "_img")) && document.getElementById((betId + "_img")).classList.contains("active_win")) {
                //         document.getElementById(betId + "_img").classList.remove("active_win");
                //     }
                // }


                if (this.props.isPlayerBanned) {
                    this.closeGame();
                    this.props.player_banned();
                }

                //console.log("gameUnderMaintanance " + props.gameUnderMaintanance);
                if (this.props.gameUnderMaintanance) {
                    this.closeGame();
                    this.props.game_maintanance("Game under maintenance, reach to admin.");
                }

                //console.log("deviceBlocked " + props.isdeviceBlocked);
                if (this.props.isdeviceBlocked) {
                    this.closeGame();
                    this.props.device_blocked();
                }
            }, 2000)

            if (this.state.isGameActive) {
                if (document.getElementById("winPop")) {
                    document.getElementById("winPop").style.display = "block"
                    // document.getElementById("sparkAnim").src = {staranimation}
                    if (this.sparkleImagesLoaded < 100) {
                        console.log("Sparkle images still loading...");
                        return;
                    }
                    this.dragonsparklemw = 1;
                    // this.dragponsparkl = setInterval(this.dragonsparkleanimat, 35);
                    this.dragonSparkleImgEl = document.getElementById("dragon_sprkl")
                    this.startSparkleAnim()
                }
                this.table_timeout9 = setTimeout(() => {
                    if (document.getElementById("winPop")) {
                        document.getElementById("winPop").style.display = "none";
                    }
                }, 3000);

                this.table_timeout15 = setTimeout(() => {
                    //this.enableBtn("dealBtn_dtt");
                    // if (document.getElementById("dealBtn_dtt")) {
                    //     document.getElementById("dealBtn_dtt").classList.add("dr_bt_active");
                    // }

                }, 3000);

                this.table_timeout10 = setTimeout(() => {
                    this.setState({
                        isstaranimation: false,
                    });
                }, 1700);
            }

        } else {
            if (this.state.isGameActive) {
                if (document.getElementById('iospopup').style.display == "none") {
                    this.loseSound.play();
                }
            }
            // this.setState({ infoText: this.props.language.Play_Njoy });

            // this.disableBtn("unDoBtn_dtt");

            // if (this.props.gameState.betRequest && this.props.gameState.betRequest.betAmount > 0 && this.props.gameState.betRequest.betString) {

            // } else {
            //     this.disableBtn("dealBtn_dtt");
            // }

            if (document.getElementById("dealBtn_dtt")) {
                document.getElementById("dealBtn_dtt").classList.remove("dr_bt_active");
            }

            // this.table_timeout11 = setTimeout(() => {
            //     this.undoArray = []
            //     // this.cleareBets();
            //     this.newGame()
            //     this.setState({
            //         betBtnStatus: 0,
            //         betBtnTxt: this.props.language.Prev,
            //         enableKeyboard: true,
            //         winCover: false,
            //         isResultShowing: false
            //     });

            //     // if (document.getElementById("betBoxCover")) {
            //     //     document.getElementById("betBoxCover").style.zIndex = 99;
            //     //     document.getElementById("betBoxCover").style.display = "none";
            //     // }

            //     if (this.props.gameState.betRequest && this.props.gameState.betRequest.betAmount > 0 && this.props.gameState.betRequest.betString) {
            //         this.enableBtn("dealBtn_dtt");
            //     }
            // }, 2500);

            this.table_timeout7 = setTimeout(() => {
                let body = {
                    sessionId: sessionStorage.getItem('sessionId'),
                    CN: "GET_GAME_STATE",
                    object: {
                        playerId: Number(this.props.playerId),
                        gameId: this.props.gameId,
                    },
                };
                this.props.network.sendof(body);
                let body2 = {
                    CN: "GET_PLAYER_INFO",
                    object: {
                        gameId: Number(this.props.gameId),
                        playerId: Number(this.props.playerId),
                    },
                    sessionId: sessionStorage.getItem('sessionId'),
                };
                this.props.network.sendof(body2);
            }, 500)
            // this.setState({ totalBetAmount: 0 });
        }


        for (let a = 0; a < this.winBetArray.length; a++) {
            if (document.getElementById((this.winBetArray[a] + "_img"))) {
                document.getElementById((this.winBetArray[a] + "_img")).classList.add("active_win");
            }
        }
    }

    /**************************** YOUR BET AMOUNT ON WIN BOX *************************/
    winBoxBetAmount(ids, vals) {
        let id = ids;
        let val = vals;
        for (let i = 0; i < id.length; i++) {
            if (val[i] > 0) {
                if (document.getElementById(id[i])) {
                    let num_id6 = id[i] + "_id";
                    let win_amt = val[i];
                    const container = document.getElementById(id[i]);
                    const root = ReactDOM.createRoot(container);
                    // document.getElementById(id[i]).innerHTML = `<div> <p class="goldCoin_dr" } /> <span class="t_Count" id=${num_id6}> ${win_amt} </span </div>`
                    root.render(<div className="betPlacedChip "><BetPlacedChip betAmount={win_amt} gameId={20} chipString={this.props.dtt_chipValues} /></div>);

                }
            }
        }
    }

    /****************************** GETTING ALL IDS OF BET PANEL **********************/
    getAllIds() {
        this.allIds = this.state.betPanelIds;

        let betIdObj = {};
        betIdObj = this.betObj;

        for (let i = 0; i < Object.getOwnPropertyNames(betIdObj.dragon).length; i++) {
            let dragonIds = document.getElementById(Object.getOwnPropertyNames(betIdObj.dragon)[i]);
            this.allIds.push(dragonIds.id);

            let tigerIds = document.getElementById(Object.getOwnPropertyNames(betIdObj.tiger)[i]);
            this.allIds.push(tigerIds.id);
        }
        let tieIds = document.getElementById(Object.getOwnPropertyNames(betIdObj.tie)[0]);
        if (this.state.betPanelIds.length < 7) {
            this.allIds.push(tieIds.id);
        }
    };


    /************************ UNDO BET BUTTON *****************************/
    undoFun = () => {
        console.log("Current betObj:", this.betObj);
        console.log("Current undoArray:", this.undoArray);

        this.setState({ infoText: this.props.language.Play_Njoy });

        // Disable Undo button if this is the last undo
        if (this.undoArray.length === 1) {
            this.disableBtn("unDoBtn_dtt");
        }

        // Proceed if undo array is not empty
        if (this.undoArray.length !== 0) {
            let undoLog = this.undoArray;
            let resObj = undoLog.at(-1); // get last placed bet

            console.log("Undoing last bet:", resObj);

            undoLog.splice(-1); // remove last item

            const id = Object.keys(resObj)[0];
            const val = Number(Object.values(resObj)[0]);

            this.undoBet(id, val); // Undo the specific bet
        } else {
            // No more undo history, reset UI if applicable
            const { betRequest } = this.props.gameState || {};
            if (betRequest && betRequest.betAmount > 0 && betRequest.betString) {
                this.setState({
                    betBtnStatus: 0,
                    betBtnTxt: this.props.language.Prev,
                });
                this.enableBtn("dealBtn_dtt");
            }
            this.disableBtn("doubleBtn_dtt");
        }
    };

    /************************ UNDO BET FUNCTIONALITY *****************************/
    undoBet(id, val) {
        const container = document.getElementById(id);
        const root = ReactDOM.createRoot(container);

        const undoBetObj = this.betObj;
        const receiveVal = Number(Number(val).toFixed(2));
        const remainingAmt = Number((this.state.totalBetAmt - receiveVal).toFixed(2));

        // Update bet and UI states
        this.setState({
            totalBetAmt: remainingAmt,
            totalBetAmount: remainingAmt,
            betAmount: remainingAmt
        });

        // Handle UI reset if all bets are undone
        if (remainingAmt === 0) {
            this.disableBtn("unDoBtn_dtt");
            this.disableBtn("dealBtn_dtt");
            this.disableBtn("clrBtn_dtt");
            this.disableBtn("doubleBtn_dtt");

            const { betRequest } = this.props.gameState || {};
            if (betRequest && betRequest.betAmount > 0 && betRequest.betString) {
                this.setState({
                    betBtnStatus: 0,
                    betBtnTxt: this.props.language.Prev,
                });
                this.enableBtn("dealBtn_dtt");
            }

            document.getElementById("dealBtn_dtt")?.classList.remove("dr_bt_active");
        }

        // === Handle bet type update: dragon / tiger / tie ===
        const updateGroup = (groupName) => {
            const group = undoBetObj[groupName];
            if (!group || !(id in group)) return;

            let updatedVal = Number((group[id] - receiveVal).toFixed(2));
            group[id] = Number((Math.round(updatedVal * 100) / 100).toFixed(2));

            if (group[id] !== 0) {
                // Render updated bet chip
                root.render(
                    <div className="betPlacedChip">
                        <BetPlacedChip
                            betAmount={group[id]}
                            gameId={20}
                            chipString={this.props.dtt_chipValues}
                        />
                    </div>
                );
            } else {
                // Remove chip if amount is 0
                root.render(<div className="betPlacedChip"></div>);
            }
        };

        // Try updating bet from each group
        updateGroup("dragon");
        updateGroup("tie");
        updateGroup("tiger");

        // Save updated object
        this.betObj = undoBetObj;

        console.log("Updated betObj after undo:", this.betObj);
    }



    stopBetSound() {
        // this.betChipSound.currentTime = 0;
        // this.betChipSound.pause();

        this.setState({ enableKeyboard: true });
        this.state.enableKeyboard = true;
    }

    chipValue(chipVal) {
        this.setState({
            chipValue: Number(chipVal)
        })

    }

    convertBetValue(chngAmt) {

        let newAmt = Number((chngAmt).toFixed(2));
        if (newAmt >= 1000 && newAmt <= 999999) {
            newAmt = Number((newAmt / 1000).toFixed(2)) + "K";
        } else if (newAmt >= 1000000 && newAmt <= 999999999) {
            newAmt = Number((newAmt / 1000).toFixed(2)) + "M";
        } else if (newAmt > 999999999) {
            newAmt = Number((newAmt / 1000).toFixed(2)) + "B";
        }
        return newAmt;
    }

    changeAmtlabl(chngAmt) {
    }

    /************************ BET ONCLICK ON BET BOX *****************************/

    getBetBoxId(idName) {
        this.setState({ enableKeyboard: false });
        this.state.enableKeyboard = false;
        const container = document.getElementById(idName);
        const root = ReactDOM.createRoot(container);
        // console.log(" --------------------------***********************----------------------------------- ")
        if (this.state.totalBetAmount == 0) {
            for (let j = 0; j < this.coinId.length; j++) {
                let betId = this.coinId[j];
                if (document.getElementById((betId + "_img")) && document.getElementById((betId + "_img")).classList.contains("active_win")) {
                    document.getElementById(betId + "_img").classList.remove("active_win");
                }
            }
        }

        // console.log(this.state.chipValue);
        // console.log(this.resetBet);
        // console.log(this.betObj);
        let currentBtnAmt = 0;

        for (let s = 0; s < 3; s++) {
            currentBtnAmt = Number(currentBtnAmt) + Number(Object.values(this.betObj.tiger)[s]);
            currentBtnAmt = Number(currentBtnAmt) + Number(Object.values(this.betObj.dragon)[s]);
        }
        currentBtnAmt = Number(currentBtnAmt) + Number(Object.values(this.betObj.tie)[0]);

        console.log(currentBtnAmt);
        console.log(this.state.totalBetAmount);
        console.log(this.props.maxBetAmt);
        this.setState({ infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl });

        // this.setState({
        //     infoText: this.props.language.Min_Bet + " " + this.props.minBetAmt + " " + this.props.language.Max_Bet + " " + this.props.maxBetAmt
        // })


        if (currentBtnAmt + Number(this.state.chipValue) <= this.props.balance) {
            console.log((currentBtnAmt + Number(this.state.chipValue) <= this.props.maxBetAmt))
            if (currentBtnAmt + Number(this.state.chipValue) <= this.props.maxBetAmt) {
                // this.betChipSound.currentTime = 0;
                // this.betChipSound.play();
                this.playPokerBetSound(this.betChipSound);

                console.log(this.state.totalBetAmount);
                console.log(this.state.chipValue);

                let betAmt = this.state.totalBetAmount;
                let chipVal = this.state.chipValue;
                let totbetAmt = Number((Number(betAmt) + Number(chipVal)).toFixed(2));
                console.log(totbetAmt);

                console.log("Total Bet Amount: " + this.state.totalBetAmt)
                console.log("currentBtnAmt: " + (Number(currentBtnAmt) + Number(this.state.chipValue)))

                this.setState({ balanceLbl: (this.props.balance - (Number(currentBtnAmt) + Number(this.state.chipValue))) })

                if (Number(currentBtnAmt) + Number(this.state.chipValue) > 0) {
                    console.log(this.state.betBtnStatus)
                    if (this.state.betBtnStatus != 1) {
                        this.setState({
                            betBtnStatus: 1,
                            betBtnTxt: this.props.language.BetOK,
                        });
                        this.enableBtn("dealBtn_dtt");
                        if (document.getElementById("dealBtn_dtt")) {
                            document.getElementById("dealBtn_dtt").classList.add("dr_bt_active");
                        }
                    }
                    if (document.getElementById("unDoBtn_dtt") && document.getElementById("unDoBtn_dtt").disabled) {
                        this.enableBtn("unDoBtn_dtt");
                    }
                    if (document.getElementById("clrBtn_dtt") && document.getElementById("clrBtn_dtt").disabled) {
                        this.enableBtn("clrBtn_dtt");
                    }
                    if (document.getElementById("doubleBtn_dtt") && document.getElementById("doubleBtn_dtt").disabled) {
                        this.enableBtn("doubleBtn_dtt");
                    }
                }

                let inrMaxLmt;

                switch (idName) {
                    case "dr":
                    case "tr":
                        inrMaxLmt = this.innerLimits[0][1];
                        break;
                    case "ti":
                        inrMaxLmt = this.innerLimits[1][1];
                        break;
                    case "dbig":
                    case "tbig":
                    case "dsml":
                    case "tsml":
                        inrMaxLmt = this.innerLimits[2][1];
                        break;
                }

                let betArray = {};
                betArray = this.betObj;

                for (let i = 0; i < Object.getOwnPropertyNames(this.betObj.dragon).length; i++) {

                    if (Object.getOwnPropertyNames(this.betObj.dragon)[i] == idName) {

                        let checkVal = Number(this.betObj.dragon[idName]);

                        if ((Number(checkVal) + Number(this.state.chipValue)) <= this.props.maxBetAmt) {
                            if (Number(this.betObj.dragon[idName] + Number(this.state.chipValue) <= Number(inrMaxLmt))) {
                                betArray.dragon[idName] = Number((Number(this.betObj.dragon[idName]) + Number(this.state.chipValue)).toFixed(2));
                                checkVal = Number(this.betObj.dragon[idName]);

                                console.log("checkVal: " + checkVal);

                                // if (Number(checkVal) >= 1000 && Number(checkVal) <= 999999) {
                                //     checkVal = checkVal / 1000 + "K";
                                //     console.log(checkVal);
                                //   } else if (checkVal >= 1000000 && checkVal <= 999999999) {
                                //     checkVal = checkVal / 1000 + "M";
                                //     console.log(checkVal);
                                //   } else if (checkVal > 999999999) {
                                //     checkVal = checkVal / 1000 + "B";
                                //     console.log(checkVal);
                                //   }

                                checkVal = checkVal;


                                this.setState({ totalBetAmount: this.state.betAmount, totalBetAmt: totbetAmt });
                                // let oldAndNewDragon = Number(betArray.dragon[idName]) + Number(value);
                                this.undoArray.push({ [idName]: Number(this.state.chipValue) });
                                let num_id = idName + "_id";
                                // document.getElementById(idName).innerHTML = `<div> <p class="goldCoin_dr" } /> <span class="t_Count" id=${num_id}> ${checkVal} </span </div>`;
                                root.render(<div className="betPlacedChip "><BetPlacedChip betAmount={checkVal} gameId={20} chipString={this.props.dtt_chipValues} /></div>);

                            }
                        } else {
                            this.setState({
                                infoText: this.props.language.LowBalance
                            })
                        }
                    } else if (Object.getOwnPropertyNames(this.betObj.tie)[i] == idName) {

                        if ((this.betObj.tie[idName] + Number(this.state.chipValue)) <= this.props.maxBetAmt) {
                            if (Number(this.betObj.tie[idName] + Number(this.state.chipValue) <= Number(inrMaxLmt))) {
                                this.setState({ totalBetAmount: this.state.betAmount, totalBetAmt: totbetAmt });
                                betArray.tie[idName] = Number((Number(this.betObj.tie.ti) + Number(this.state.chipValue)).toFixed(2));
                                var checkVal2 = this.betObj.tie[idName]
                                //console.log("checkVal2: " + checkVal2); 
                                let betVal2 = checkVal2;
                                this.undoArray.push({ [idName]: Number(this.state.chipValue) });
                                let num_id2 = idName + "_id";
                                // document.getElementById(idName).innerHTML = `<div> <p class="goldCoin_dr" } /> <span class="t_Count" id=${num_id3}> ${betVal2} </span </div>`;
                                root.render(<div className="betPlacedChip "><BetPlacedChip betAmount={betVal2} gameId={20} chipString={this.props.dtt_chipValues} /></div>);


                            }
                        } else {
                            this.setState({
                                infoText: this.props.language.LowBalance
                            })
                        }

                    } else if (Object.getOwnPropertyNames(this.betObj.tiger)[i] == idName) {
                        if ((this.betObj.tiger[idName] + Number(this.state.chipValue)) <= this.props.maxBetAmt) {
                            if (Number(this.betObj.tiger[idName] + Number(this.state.chipValue) <= Number(inrMaxLmt))) {
                                this.setState({ myBetAmt: this.state.myBetAmt + 100 });
                                betArray.tiger[idName] = Number((Number(this.betObj.tiger[idName]) + Number(this.state.chipValue)).toFixed(2));
                                let checkVal3 = this.betObj.tiger[idName];
                                let betVal3 = checkVal3;
                                // this.setState({ totalBetAmt: (this.state.totalBetAmount + this.state.chipValue) });
                                this.setState({ totalBetAmount: this.state.betAmount, totalBetAmt: totbetAmt });
                                this.undoArray.push({ [idName]: Number(this.state.chipValue) });
                                let num_id3 = idName + "_id";
                                // document.getElementById(idName).innerHTML = `<div> <p class="goldCoin_dr" } /> <span class="t_Count" id=${num_id3}> ${betVal3} </span </div>`;
                                root.render(<div className="betPlacedChip "><BetPlacedChip betAmount={betVal3} gameId={20} chipString={this.props.dtt_chipValues} /></div>);


                            }
                        } else {
                            this.setState({
                                infoText: this.props.language.LowBalance
                            })
                        }
                    }
                }

                let myAmt = 0;
                for (let j = 0; j < 3; j++) {
                    myAmt += Number(Object.values(betArray.tiger)[j]);
                    myAmt += Number(Object.values(betArray.dragon)[j]);
                }
                myAmt += Number(Object.values(betArray.tie)[0]);
                this.setState({ totalBetAmount: myAmt });
                this.betObj = betArray;
            } else {
                // this.setState({
                //     infoText: this.props.language.Min_Bet + " " + this.props.minBetAmt + " " + this.props.language.Max_Bet + " " + this.props.maxBetAmt
                // })
                this.setState({ infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl });

            }
        } else {
            this.setState({
                infoText: this.props.language.LowBalance
            })
        }

        //console.log(this.undoArray)
    }

    /************************ CLEARE BET *****************************/
    cleareBets = () => {
        //console.log("Clear Bets " + Number(totalBetAmt));
        this.disableBtn("dealBtn_dtt");
        this.disableBtn("unDoBtn_dtt");
        this.disableBtn("clrBtn_dtt");
        this.disableBtn("doubleBtn_dtt");

        if (this.props.gameState.betRequest && this.props.gameState.betRequest.betAmount > 0) {
            this.setState({
                betBtnStatus: 0,
                betBtnTxt: this.props.language.Prev,
            });
            this.enableBtn('dealBtn_dtt');
        } else {
            this.setState({
                betBtnStatus: 0,
                betBtnTxt: this.props.language.Prev,
            });
            this.disableBtn('dealBtn_dtt');
        }

        if (document.getElementById("dealBtn_dtt")) {
            document.getElementById("dealBtn_dtt").classList.remove("dr_bt_active");
        }
        // if (document.getElementById("betBoxCover")) {
        //     document.getElementById("betBoxCover").style.display = "none";
        // }
        // console.log(this.betObj);

        for (let j = 0; j < this.coinId.length; j++) {
            let betId = this.coinId[j];
            // if (document.getElementById(betId)) {
            //     document.getElementById(betId).innerHTML = `<div> <p class="goldCoin_dr" } /> </div>`;
            // }
            const container = document.getElementById(betId);
            if (container) {
                const root = ReactDOM.createRoot(container);
                root.render(<div className="betPlacedChip "></div>);
            }
        }

        this.setState({
            infoText: this.props.language.Play_Njoy,
            undoArray: [],
            balanceLbl: this.props.balance,
            totalBetAmt: 0,
            totalBetAmount: 0,
            winCover: false
        })
        this.undoArray = []

        this.betObj.dragon["dr"] = 0;
        this.betObj.dragon["dbig"] = 0;
        this.betObj.dragon["dsml"] = 0;
        this.betObj.tie["ti"] = 0;
        this.betObj.tiger["tr"] = 0;
        this.betObj.tiger["tbig"] = 0;
        this.betObj.tiger["tsml"] = 0;

        // if (this.props.gameState.betRequest && this.props.gameState.betRequest.betAmount > 0) {
        //     this.setState({
        //         betBtnStatus: 0,
        //         betBtnTxt: this.props.language.Prev,
        //     });
        //     this.enableBtn('dealBtn_dtt');
        // } else {
        //     this.disableBtn('dealBtn_dtt');
        // }
        console.log(this.betObj);
    }

    TakeAmount_fn = () => {

        let dragonWinCard = document.getElementById('dragonWinCard');
        let tigerWinCard = document.getElementById('tigerWinCard');
        if (dragonWinCard) {
            dragonWinCard.innerHTML = ``
        }
        if (tigerWinCard) {
            tigerWinCard.innerHTML = ``
        }

        document.getElementById("dealBtn_dtt").classList.remove("dr_bt_active");
        let take_body = {
            sessionId: sessionStorage.getItem('sessionId'),
            CN: "TAKE_AMOUNT",
            object: {
                gameId: this.props.gameId,
                playerId: Number(this.props.playerId),
            },
        };
        this.props.network.sendof(take_body);

        let gs_body = {
            sessionId: sessionStorage.getItem('sessionId'),
            CN: "GET_GAME_STATE",
            object: {
                playerId: Number(this.props.playerId),
                gameId: this.props.gameId,
            },
        };
        this.props.network.sendof(gs_body);

        document.getElementById("betBoxCover").style.display = "none";
        document.getElementById("betBoxCover").style.zIndex = 99;

        this.betObj.dragon["dr"] = 0;
        this.betObj.dragon["dbig"] = 0;
        this.betObj.dragon["dsml"] = 0;
        this.betObj.tie["ti"] = 0;
        this.betObj.tiger["tr"] = 0;
        this.betObj.tiger["tbig"] = 0;
        this.betObj.tiger["tsml"] = 0;

        this.setState({
            betBtnStatus: 0,
            betBtnTxt: this.props.language.Prev,
            infoText: this.props.language.Play_Njoy,
            totalBetAmount: 0,
            totalBetAmt: 0,
            winCover: false,
            winAmount: 0,
            undoArray: [],
        });
        this.enableBtn("dealBtn_dtt");

        for (let j = 0; j < this.coinId.length; j++) {
            let betId = this.coinId[j];
            // document.getElementById(betId).innerHTML = `<div> <p class="goldCoin_dr" } /> </div>`;
            const container = document.getElementById(betId);
            if (container) {
                const root = ReactDOM.createRoot(container);
                root.render(<div className="betPlacedChip "></div>);
            }
            if (document.getElementById((betId + "_img")) && document.getElementById((betId + "_img")).classList.contains("active_win")) {
                document.getElementById(betId + "_img").classList.remove("active_win");
            }
        }
        if (this.props.isPlayerBanned) {
            this.closeGame();
            this.props.player_banned();
        }

        //console.log("gameUnderMaintanance " + props.gameUnderMaintanance);
        if (this.props.gameUnderMaintanance) {
            this.closeGame();
            this.props.game_maintanance("Game under maintenance, reach to admin.");
        }

        //console.log("deviceBlocked " + props.isdeviceBlocked);
        if (this.props.isdeviceBlocked) {
            this.closeGame();
            this.props.device_blocked();
        }
    }

    /************************ REBET FUNCTIONALITY *****************************/
    rebetFun = () => {
        if (this.props.gameState.betRequest && this.props.gameState.betRequest.betAmount <= this.props.balance) {
            this.updateBetString();

            for (let a = 0; a < this.winBetArray.length; a++) {
                if (document.getElementById((this.winBetArray[a] + "_img"))) {
                    document.getElementById((this.winBetArray[a] + "_img")).classList.remove("active_win");
                }
            }

            console.log("Previous Bet");
            console.log(this.state.totalBetAmt);
            console.log(this.props.balance);
            // console.log(undoArray)
            // console.log(props.gameState.betRequest.betAmount);

            if (this.state.totalBetAmt <= this.props.balance) { //Changed total bet variable
                if (this.state.totalBetAmt > this.props.maxBetAmt) { //Changed total bet variable
                    this.setState({
                        infoText: this.props.language.PreBetLmt
                    })
                } else {
                    console.log("Rebet: betObj 0 : ");

                    this.setState({ infoText: this.props.language.Play_Njoy, winCover: false })

                    // document.getElementById("betBoxCover").style.display = "none";

                    let reBetObj = [];
                    reBetObj = this.betObj;

                    let rebArray = this.betObj;
                    let redoIdArray = [];
                    let redoValuesArray = [];

                    var totalVal = 0;
                    for (let i = 0; i < 7; i++) {
                        if (Object.getOwnPropertyNames(reBetObj.dragon)[i] != undefined && Object.getOwnPropertyNames(reBetObj.dragon)[i] == Object.keys(rebArray.dragon)[i]) {
                            redoIdArray.push(Object.keys(rebArray.dragon)[i]);
                            redoValuesArray.push(Object.values(rebArray.dragon)[i]);
                            reBetObj.dragon[Object.keys(rebArray.dragon)[i]] = Object.values(rebArray.dragon)[i];

                            let valNo = Object.values(rebArray.dragon)[i];
                            if (valNo !== "") {
                                totalVal += Number(valNo);
                                if (valNo > 0) {
                                    this.undoArray.push({ [Object.keys(rebArray.dragon)[i]]: Number(valNo) });
                                }
                            }
                        }
                        if (Object.getOwnPropertyNames(reBetObj.tiger)[i] != undefined && Object.getOwnPropertyNames(reBetObj.tiger)[i] == Object.keys(rebArray.tiger)[i]) {
                            redoIdArray.push(Object.keys(rebArray.tiger)[i]);
                            redoValuesArray.push(Object.values(rebArray.tiger)[i]);
                            reBetObj.tiger[Object.keys(rebArray.tiger)[i]] = Object.values(rebArray.tiger)[i];

                            let valNo = Object.values(rebArray.tiger)[i];
                            if (valNo !== "") {
                                totalVal += Number(valNo);
                                if (valNo > 0) {
                                    this.undoArray.push({ [Object.keys(rebArray.tiger)[i]]: Number(valNo) });
                                }
                            }
                        }
                    }

                    if (Object.values(rebArray.tie)[0] !== "" && Object.values(rebArray.tie)[0] > 0) {
                        this.undoArray.push({ [Object.keys(rebArray.tie)[0]]: Number(Object.values(rebArray.tie)[0]) });
                    }
                    redoIdArray.push(Object.keys(rebArray.tie)[0]);
                    redoValuesArray.push(Object.values(rebArray.tie)[0]);
                    reBetObj.tie[Object.keys(rebArray.tie)[0]] = Object.values(rebArray.tie)[0];

                    let valNo = Object.values(rebArray.tie)[0];
                    if (valNo !== "") {
                        totalVal += Number(valNo);
                    }
                    this.rebetSetToGame(redoIdArray, redoValuesArray);
                    this.setState({
                        betBtnStatus: 1,
                        betBtnTxt: this.props.language.BetOK,
                    });
                    this.enableBtn("dealBtn_dtt");
                    this.enableBtn("clrBtn_dtt");
                    this.enableBtn("unDoBtn_dtt");
                    this.enableBtn("doubleBtn_dtt");
                    document.getElementById("dealBtn_dtt").classList.add("dr_bt_active");
                }
            } else {
                this.setState({ infoText: this.props.language.BetAmtMaxBal });
            }
        } else {
            this.setState({ infoText: this.props.language.BetAmtMaxBal });
        }
    }

    rebetSetToGame(ids, vals) {
        console.log(ids);
        console.log(ids.length);
        console.log(vals);
        let betAmt = 0;

        for (let j = 0; j < ids.length; j++) {
            console.log(vals[j]);
            if (vals[j] > 0) {
                // let amtLbl = changeAmtlabl(vals[j])
                betAmt += Number(vals[j]);
                let num_id4 = ids[j] + "_id";

                let betVal_id4 = vals[j];

                // document.getElementById(ids[j]).innerHTML = `<div> <p class="goldCoin_dr" } /> <span class="t_Count" id=${num_id4}> ${betVal_id4} </span </div>`;
                const container = document.getElementById(ids[j]);
                if (container) {
                    const root = ReactDOM.createRoot(container);
                    root.render(<div className="betPlacedChip "><BetPlacedChip betAmount={betVal_id4} gameId={20} chipString={this.props.dtt_chipValues} /></div>);
                }
            }
        }
        this.setState({ totalBetAmt: betAmt, totalBetAmount: betAmt });
    }

    /************************ DOUBLE *****************************/
    double = () => {
        console.log("Double bet amount:", this.state.totalBetAmt);
        console.log("Undo Array:", this.undoArray);

        const { totalBetAmt, betidReq } = this.state;
        const { balance, maxBetAmt, language, minBetLbl, maxBetLbl } = this.props;

        // ✅ Check: Balance & Max Bet Limit
        if (totalBetAmt * 2 > balance) {
            return this.setState({ infoText: language.LowBalance });
        }

        if (totalBetAmt * 2 > maxBetAmt) {
            return this.setState({
                infoText: `${language.MinBetAmt} ${minBetLbl} ${language.MaxBetAmt} ${maxBetLbl}`
            });
        }

        // === Prepare objects ===
        let betArray = { ...this.betObj };
        let newBetAmt = 0;
        let allBetArray = [];

        betidReq.forEach((betId) => {
            let doubleBetValue = this.extractNumericValue(betId);
            if (!doubleBetValue) return;

            let limitIndex = this.getLimitIndex(betId);
            const limit = Number(this.innerLimits[limitIndex][1]);

            let container = document.getElementById(betId);
            let doubleAmount = doubleBetValue * 2;
            const isValidDouble = doubleAmount <= limit;

            const assignBet = (group, value) => {
                betArray[group][betId] = value;
                newBetAmt += value;
                allBetArray.push({ [betId]: value });
            };

            switch (betId) {
                case "dr":
                case "dbig":
                case "dsml":
                    assignBet("dragon", isValidDouble ? doubleAmount : doubleBetValue);
                    break;

                case "tr":
                case "tbig":
                case "tsml":
                    assignBet("tiger", isValidDouble ? doubleAmount : doubleBetValue);
                    break;

                case "ti":
                    assignBet("tie", isValidDouble ? doubleAmount : doubleBetValue);
                    break;

                default:
                    console.warn(`Unknown bet ID: ${betId}`);
                    return;
            }

            // Display chip component in DOM
            if (container && isValidDouble) {
                const root = ReactDOM.createRoot(container);
                root.render(
                    <div className="betPlacedChip">
                        <BetPlacedChip
                            betAmount={doubleAmount}
                            gameId={20}
                            chipString={this.props.dtt_chipValues}
                        />
                    </div>
                );
            }

            if (!isValidDouble) {
                this.setState({ infoText: language.MaxInrBetAmt + limit });
            }
        });

        // === Update state and undo history ===
        this.setState({
            totalBetAmt: newBetAmt,
            totalBetAmount: newBetAmt,
            balanceLbl: balance - newBetAmt
        });

        this.undoArray = allBetArray.length > 0 ? allBetArray : this.undoArray;
        this.betObj = betArray;

        console.log("Updated Undo Array:", this.undoArray);
        console.log("Updated Bet Object:", this.betObj);
    };

    /************************ DOUBLE *****************************/

    // Extract numeric value from DOM element (K, M, B support)
    extractNumericValue = (betId) => {
        const el = document.getElementById(betId);
        if (!el) return 0;

        const text = el.innerText.trim();
        const match = text.match(/^(\d+(\.\d+)?)([a-zA-Z]+)?$/);

        if (!match) return parseFloat(text) || 0;

        let [_, number, __, unit] = match;
        let multiplier = 1;

        switch (unit?.toUpperCase()) {
            case "K": multiplier = 1000; break;
            case "M": multiplier = 1000000; break;
            case "B": multiplier = 1000000000; break;
        }

        return parseFloat(number) * multiplier;
    };

    // Determine limit index based on betId (innerLimits group)
    getLimitIndex = (betId) => {
        if (["dr", "tr"].includes(betId)) return 0;
        if (["ti"].includes(betId)) return 1;
        return 2; // dbig, dsml, tbig, tsml
    };



    /************************ DEAL *****************************/

    deal = () => {
        // this.disableBtn("dealBtn_dtt");
        document.getElementById("betBoxCover").style.display = "block";
        console.log(this.state.totalBetAmt + '    ' + this.state.totalBetAmount)
        if (Number(this.state.totalBetAmount) > 0) {
            if (Number(this.state.totalBetAmount) < Number(this.props.minBetAmt)) {
                this.enableBtn("dealBtn_dtt")
                // this.setState({infoText: this.props.language.Min_Bet + " " + this.props.minBetAmt + " " + this.props.language.Max_Bet + " " + this.props.maxBetAmt});
                this.setState({ infoText: this.props.language.MinBetAmt + " " + this.props.minBetLbl + " " + this.props.language.MaxBetAmt + " " + this.props.maxBetLbl });
            } else {
                this.setState({ infoText: this.props.language.Bet_Processing_Msg });
                this.placebet();
            }
        } else {
            document.getElementById("betBoxCover").style.display = "none";
        }
    }

    disableBtns = () => {
        this.setState({
            enableKeyboard: false
        })
        this.disableBtn("dealBtn_dtt");
        this.disableBtn("unDoBtn_dtt");
        this.disableBtn("clrBtn_dtt");
        this.disableBtn("doubleBtn_dtt");
        if (document.getElementById("dealBtn_dtt")) {
            document.getElementById("dealBtn_dtt").classList.remove("dr_bt_active");
        }
    }

    /************************ PLACE BET *****************************/
    placebet = () => {
        let betReq = [
            [Number(this.betObj.dragon.dr.toFixed(2)), Number(this.betObj.tiger.tr.toFixed(2))],
            [Number(this.betObj.tie.ti.toFixed(2))],
            [Number(this.betObj.dragon.dbig.toFixed(2)), Number(this.betObj.dragon.dsml.toFixed(2)), Number(this.betObj.tiger.tbig.toFixed(2)), Number(this.betObj.tiger.tsml.toFixed(2))]
        ];
        console.log(betReq)
        if (this.props.balance >= this.state.totalBetAmt) {
            this.disableBtn("unDoBtn_dtt");
            this.disableBtn("dealBtn_dtt");
            this.disableBtn("clrBtn_dtt");
            this.disableBtn("doubleBtn_dtt");

            this.setState({
                enableKeyboard: false,
                winCover: true
            })

            let dragonWinCard = document.getElementById('dragonWinCard');
            let tigerWinCard = document.getElementById('tigerWinCard');
            if (dragonWinCard) {
                dragonWinCard.innerHTML = ``
            }
            if (tigerWinCard) {
                tigerWinCard.innerHTML = ``
            }

            document.getElementById("dealBtn_dtt")?.classList.remove("dr_bt_active");
            // document.getElementById("betBoxCover").style.display = "block";
            // document.getElementById("betBoxCover").style.zIndex = 300;
            document.getElementById("betBoxCover").style.zIndex = 10000;

            let arrStr = betReq.toString();
            let betReq2 = arrStr.replace(/,/g, '|');
            let pipeIndex = [];
            for (let k = 0; k < betReq2.length; k++) {
                if (betReq2[k] == '|') {
                    pipeIndex.push(k);
                }
            }

            betReq2[pipeIndex[1]].replace('|', ',');
            let setCharAt = (str, index, chr) => {
                if (index > str.length - 1) return str;
                return str.substring(0, index) + chr + str.substring(index + 1);
            }

            betReq2 = setCharAt(betReq2, pipeIndex[1], ',');
            betReq2 = setCharAt(betReq2, pipeIndex[2], ',');
            this.setState({ isBetSent: true });

            let dt_bet_body = {
                sessionId: sessionStorage.getItem('sessionId'),
                CN: "DRAGON_TIGER_TIMER_BET",
                handId: Number(this.props.gameState.handId),
                object: {
                    betString: betReq2,
                    playerId: Number(this.props.playerId),
                    gameId: this.props.gameId,
                    betAmount: Number(this.state.totalBetAmt).toFixed(2),
                },
            };
            this.props.network.sendof(dt_bet_body);

            let pinfo_body = {
                CN: "GET_PLAYER_INFO",
                object: {
                    gameId: Number(this.props.gameId),
                    playerId: Number(this.props.playerId),
                },
                sessionId: sessionStorage.getItem('sessionId'),
            };
            // this.props.network.sendof(pinfo_body);


        } else {
            this.setState({
                infoText: this.props.language.LowBalance
            })
            document.getElementById("betBoxCover").style.display = "none";
            this.enableBtn("unDoBtn_dtt");
            this.enableBtn("dealBtn_dtt");
            this.enableBtn("clrBtn_dtt");
            this.enableBtn("doubleBtn_dtt");

            this.setState({
                enableKeyboard: true
            })
        }
    }

    closeGame = () => {
        clearTimeout(this.table_timeout1);
        clearTimeout(this.table_timeout2);
        clearTimeout(this.table_timeout3);
        clearTimeout(this.table_timeout4);
        clearTimeout(this.table_timeout5);
        clearTimeout(this.table_timeout6);
        clearTimeout(this.table_timeout7);
        clearTimeout(this.table_timeout8);
        clearTimeout(this.table_timeout9);
        clearTimeout(this.table_timeout10);
        clearTimeout(this.table_timeout11);
        clearTimeout(this.table_timeout12);
        clearTimeout(this.table_timeout13);
        clearTimeout(this.table_timeout14);
        clearTimeout(this.table_timeout15);

        // alert("Close Game")
        this.setState({ isGameActive: false, enableKeyboard: false })

        if (this.props.targetResult) {
            if (this.props.targetResult.winAmount == 0) {
                this.newGame();
            }
        }
        this.GameBox.clearTimer_fn();

        if (document.getElementById("dealBtn_dtt") && !document.getElementById("dealBtn_dtt").disabled) {
            this.cleareBets();
        }
        document.removeEventListener("keyup", this.dt_handleKeyboardEvent);
        this.props.action();
    }

    /*************************  NEW GAME START  *******************/
    newGame = () => {
        // let dragonWinCard = document.getElementById('dragonWinCard');
        // let tigerWinCard = document.getElementById('tigerWinCard');
        // if (dragonWinCard) {
        //     dragonWinCard.innerHTML = ``
        // }
        // if (tigerWinCard) {
        //     tigerWinCard.innerHTML = ``
        // }
        console.log("0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000");
        this.undoArray = []
        this.setState({
            undoArray: [], infoText: this.props.language.Play_Njoy,
            // totalBetAmount: 0,
            winCover: false
        });
        this.betObj = {
            dragon: { dr: 0, dbig: 0, dsml: 0 },
            tie: { ti: 0 },
            tiger: { tr: 0, tbig: 0, tsml: 0 },
        };
        // for (let j = 0; j < this.betObj.length; j++) {
        //     let betId = this.coinId[j];
        //     // if (document.getElementById(betId)) {
        //     //     document.getElementById(betId).innerHTML = `<div> <p class="goldCoin_dr" } /> </div>`;
        //     // }
        //     const container = document.getElementById(betId);
        //     if (container) {
        //         const root = ReactDOM.createRoot(container);
        //         root.render(<div className="betPlacedChip "></div>);
        //     }
        // }
        for (let j = 0; j < this.coinId.length; j++) {
            let betId = this.coinId[j];
            // if (document.getElementById(betId)) {
            //     document.getElementById(betId).innerHTML = `<div> <p class="goldCoin_dr" } /> </div>`;
            // }
            const container = document.getElementById(betId);
            if (container) {
                const root = ReactDOM.createRoot(container);
                root.render(<div className="betPlacedChip "></div>);
            }
        }
    }

    removeGlow = () => {
        for (let j = 0; j < this.coinId.length; j++) {
            let betId = this.coinId[j];
            if (document.getElementById((betId + "_img")) && document.getElementById((betId + "_img")).classList.contains("active_win")) {
                document.getElementById(betId + "_img").classList.remove("active_win");
            }
        }

        if (document.getElementById('dragonWinCard')) {
            document.getElementById('dragonWinCard').innerHTML = ``;
        }
        if (document.getElementById('tigerWinCard')) {
            document.getElementById('tigerWinCard').innerHTML = ``;
        }
    }

    closeWin() {
        document.getElementById('iospopup').style.display = "none";
        this.winSound = new Audio(winSoundFile);
        this.loseSound = new Audio(duploseSound);
        // this.betSound = new Audio(betSoundFile);
        this.takeBtnSnd = new Audio(takeSoundFile);
        this.clearSound = new Audio(clearSoundFile);
        this.exitSound = new Audio(exitSoundFile);
        this.initializeBet1Sound()
        this.initializeBetSound()
        this.initializeCardFallSound()
        this.initializeClearSound()
        this.initializeExitSound()
        this.initializeWinSound()
        this.initializeloseSound()
        const flatObj = { ...this.betObj.dragon, ...this.betObj.tie, ...this.betObj.tiger };

        this.undoArray = Object.entries(flatObj).filter(([key, value]) => value > 0).map(([key, value]) => ({ [key]: value }));

        this.setBetChipPlaces()
        // this.betChipSound = new Audio(betChipSnd);
    }

    topLable_fn(labelValue) {
        // Nine Zeroes for Billions
        return Math.abs(Number(labelValue)) >= 1.0e+9

            ? (Math.abs(Number(labelValue)) / 1.0e+9).toFixed(2) + "B"
            // Six Zeroes for Millions 
            : Math.abs(Number(labelValue)) >= 1.0e+6

                ? (Math.abs(Number(labelValue)) / 1.0e+6).toFixed(2) + "M"
                // Three Zeroes for Thousands
                : Math.abs(Number(labelValue)) >= 1.0e+3

                    ? (Math.abs(Number(labelValue)) / 1.0e+3).toFixed(2) + "K"

                    : Math.abs(Number(labelValue.toFixed(2)));
    }


    handleImageLoad = () => {
        const { assestsLoaderFunction } = this.props;
        assestsLoaderFunction()
    }

    render() {

        // let updateWin = this.topLable_fn(Number(this.state.winAmount));
        let updateWin = this.state.winAmount !== undefined ? (this.state.winAmount) : null;
        return (
            <React.Fragment>
                <div className="betBoxCover" id="betBoxCover"></div>
                <div className="dragGame gamePage">
                    <img src={dragonTiger_bgi} alt="Hidden Loader" className="hidden" onLoad={this.handleImageLoad} />


                    <div className="iosFetchSounds" id="iospopup" onClick={(e) => this.closeWin()}>
                        <div className="popupTooLong">
                            <div className=""> {this.props.language.Wel_DTT}</div>
                            <br></br>
                            {this.props.language.OK_Btn}

                            <br></br>
                            <br></br>
                            <div className="fd">
                                <button className="btn_iosPopup" > {this.props.language.Ok} </button>
                            </div>
                        </div>
                    </div>

                    <div className="dt_popup_back" id="winPop">

                        <img id="dragon_sprkl"
                            className="dt_sparkAnim"
                            src=""
                        />
                        <div className="dt_winpop">
                            <span className="dt_win_txt">{this.state.winAmount}</span>
                        </div>
                    </div>


                    <div className="gameBox">
                        <GameBox
                            childRef={ref => (this.GameBox = ref)}
                            ref={GameBox}
                            // chipValues={props.dt_chipValues}
                            getBetBoxId={this.getBetBoxId.bind(this)}
                            stopBetSound={this.stopBetSound.bind(this)}
                            winAmount={this.state.winAmount}
                            getTimer={this.getTimer}
                            removeGlow={this.removeGlow}
                            user={this.props.user}
                            balanceLbl={this.state.balanceLbl}
                            balancedragon={this.props.balance}
                            // action={this.closeGame}
                            betAmount={this.state.totalBetAmt}
                            totalBetAmount={this.state.totalBetAmount}
                            deal={this.deal}
                            Chek_Spec={this.Chek_Spec}
                            undoFun={this.undoFun}
                            newGame={this.newGame}
                            rebetFun={this.rebetFun}
                            doubleBetFun={this.double}
                            cleareBets={this.cleareBets}
                            takeAmount_fn={this.TakeAmount_fn}
                            minBetAmt={this.props.minBetAmt}
                            maxBetAmt={this.props.maxBetAmt}
                            language={this.props.language}
                            infoTxt={this.state.infoText}
                            dragonTigerHistoy={this.props.dragonTigerHistoy}
                            handId={this.props.gameState.handId}
                            playerId={this.props.playerId}
                            gameId={this.props.gameId}
                            betSent={this.state.isBetSent}
                            winCover={this.state.winCover}
                            network={this.props.network}
                            isMobile={this.props.isMobile || this.props.isIphone}
                            betBtnStatus={this.state.betBtnStatus}
                            betBtnTxt={this.state.betBtnTxt}
                            isGameActive={this.state.isGameActive}
                            chipValue={this.chipValue.bind(this)}
                            disableBtns={this.disableBtns}
                            dtt_chipValues={this.props.dtt_chipValues}
                            selectedChipVal={this.state.selectedChipVal}
                        ></GameBox>
                        {/* <Close
                            action={this.closeGame}>
                        </Close> */}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatesToProps = (state) => {
    return {
        language: state.languageObjs.languageObj
    }
}

export default connect(mapStatesToProps)(DragonTigerTimer)

